
// marketing, preferences, analytics
function cookiesCan( what ) {
	var now = Cookies.get( 'cookies' );

	if ( typeof now == 'undefined' ) {
		return false;
	}

	if ( now == 'all' || now.indexOf( what ) > -1 ) {
		return true;
	}

	return false;
}

function getBrowserInfo() {
	var ua= navigator.userAgent, tem,
	M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if(/trident/i.test(M[1])){
		tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
		return 'IE '+(tem[1] || '');
	}
	if(M[1]=== 'Chrome'){
		tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
		if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
	}
	M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
	if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
	return M.join(' ');
}

function isHighDensity() {
	return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
}

function isRetina() {
	if (window.matchMedia) {
		var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
		return (mq && mq.matches || (window.devicePixelRatio > 1));
	}
}

function mobileCheck() {
	var check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
}

function getSystem() {
	var os_name = 'neznamy';
	if ( navigator.appVersion.indexOf( "Win" ) != -1 ) os_name = "Windows";
	if ( navigator.appVersion.indexOf( "Mac" ) != -1 ) os_name = "MacOS";
	if ( navigator.appVersion.indexOf( "X11" ) != -1 ) os_name = "UNIX";
	if ( navigator.appVersion.indexOf( "Linux" ) != -1 ) os_name = "Linux";
	return os_name;
}

function saveBrowserInfo() {
	if ( cookiesCan( 'analytics' ) ) {
		// zakladni informace
		var browserInfo = {
			browser: getBrowserInfo(),
			highDensity: isHighDensity(),
			retina: isRetina(),
			userAgent: navigator.userAgent,
			screen_width: screen.width,
			screen_height: screen.height,
			language: navigator.language,
			system: getSystem(),
			current_width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
			current_height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
			is_mobile: mobileCheck()
		};

		Cookies.set( 'binfo_meta', JSON.stringify( browserInfo ), { expires: 7, path: '/' } );
	}
}

function saveFirstReferrer() {
	// referrer
	var cookie_referrer = Cookies.get( 'binfo_referrer' );

	if ( typeof cookie_referrer == 'undefined' && typeof document.referrer != 'undefined' ) {
		Cookies.set( 'binfo_referrer', document.referrer, { expires: 7, path: '/' } );
	}

	// first page
	var first_page = Cookies.get( 'binfo_first_page' );

	if ( typeof first_page == 'undefined' ) {
		Cookies.set( 'binfo_first_page', location.href, { expires: 7, path: '/' } );
	}
}

saveFirstReferrer();

/**
 * Verze operačního systému
 */
function getIOSversion() {
	if (/iP(hone|od|ad)/.test(navigator.platform)) {
		var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
		return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
	}
}

function getAndroidVersion(ua) {
	ua = (ua || navigator.userAgent).toLowerCase();
	var match = ua.match(/android\s([0-9\.]*)/i);
	return match ? match[1] : undefined;
}

function getWindowsVersion() {
	var OSName = "Unknown";
	if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSName="Windows 10";
	if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName="Windows 8";
	if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName="Windows 7";
	if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName="Windows Vista";
	if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName="Windows XP";
	if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName="Windows 2000";
	return OSName;
}

function getSystemInfo() {
	// návratové hodnoty
	var system_type = '';
	var system_version = '';

	// ios
	var iosVersion = getIOSversion();
	if ( typeof iosVersion != 'undefined' ) {
		system_type = 'iOS';
		system_version = iosVersion;

	} else {
		// android
		var androidVersion = getAndroidVersion();
		if ( typeof androidVersion != 'undefined' ) {
			system_type = 'Android';
			system_version = androidVersion;

		} else {
			// windows
			var system = getSystem();
			if ( system == 'Windows' ) {
				var windowsVersion = getWindowsVersion();
				system_type = 'Windows';
				system_version = windowsVersion;

			} else {
				system_type = system;
			}
		}
	}

	return {
		'type': system_type,
		'version': system_version
	};
}

function isUnsupportedBrowser() {
	// system info
	var system = getSystemInfo();

// 	//Sentry.setTag("nepodporovany_system", user.showWidget);

}
